import { useState } from 'react'
import { comparisonWindow, type Metric, type CompareMode } from '@/lib/products/salesSeriesTransforms'

const DAY_MS = 86_400_000

function todayISO(): string {
  return new Date().toISOString().slice(0, 10)
}

function fromISO(to: string, rangeDays: number): string {
  const d = new Date(`${to}T00:00:00Z`)
  return new Date(d.getTime() - (rangeDays - 1) * DAY_MS).toISOString().slice(0, 10)
}

export interface PerformanceState {
  metric: Metric
  granularity: 'daily' | 'weekly'
  rangeDays: 7 | 30 | 90
  compareMode: CompareMode
  channelId: string | null
  types: ('image' | 'text')[]
  to: string
  from: string
  cmpWin: { from: string; to: string } | null
  setMetric: (m: Metric) => void
  setGranularity: (g: 'daily' | 'weekly') => void
  setRangeDays: (d: 7 | 30 | 90) => void
  setCompareMode: (c: CompareMode) => void
  setChannelId: (id: string | null) => void
  setTypes: (t: ('image' | 'text')[]) => void
}

export function usePerformanceState(): PerformanceState {
  const [metric, setMetric] = useState<Metric>('revenue')
  const [granularity, setGranularity] = useState<'daily' | 'weekly'>('daily')
  const [rangeDays, setRangeDays] = useState<7 | 30 | 90>(30)
  const [compareMode, setCompareMode] = useState<CompareMode>('previous')
  const [channelId, setChannelId] = useState<string | null>(null)
  const [types, setTypes] = useState<('image' | 'text')[]>(['image', 'text'])

  const to = todayISO()
  const from = fromISO(to, rangeDays)
  const cmpWin = comparisonWindow(from, to, compareMode)

  return {
    metric, granularity, rangeDays, compareMode, channelId, types,
    to, from, cmpWin,
    setMetric, setGranularity, setRangeDays, setCompareMode, setChannelId, setTypes,
  }
}
